export { VideoCaptureHUD, type VideoCaptureHUDProps } from './VideoCaptureHUD';
